import { cn } from "../cn";

interface ProgressProps {
  /** 0 - 100 */
  value: number;
  className?: string;
  indicatorClassName?: string;
  "aria-label"?: string;
}

export function Progress({
  value,
  className,
  indicatorClassName,
  "aria-label": ariaLabel,
}: ProgressProps) {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div
      role="progressbar"
      aria-valuenow={Math.round(clamped)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel}
      className={cn(
        "h-2 w-full overflow-hidden rounded-full bg-muted",
        className,
      )}
    >
      <div
        className={cn(
          "h-full rounded-full bg-primary transition-[width] duration-700 ease-out",
          indicatorClassName,
        )}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
